/**
 * StatCard — compact metric tile used throughout the Command Center.
 * Matches the existing card treatment (gold border, dark surface).
 */
export default function StatCard({
  icon: Icon,
  label,
  value,
  hint,
  accent = "gold",
  testId,
  loading = false,
}) {
  const accents = {
    gold: "text-gold",
    green: "text-emerald-400",
    red: "text-red-400",
    fog: "text-bone/60",
  };
  return (
    <div
      data-testid={testId}
      className="border border-gold/15 bg-white/[0.02] p-5 md:p-6 transition-colors hover:border-gold/35"
    >
      <div className="flex items-center justify-between mb-4">
        <p className="text-[10px] tracking-[0.28em] uppercase text-bone/50">{label}</p>
        {Icon && <Icon size={14} strokeWidth={1.5} className={accents[accent]} />}
      </div>
      <p
        className={`font-serif text-3xl md:text-[2rem] leading-none ${accents[accent]} ${loading ? "opacity-30" : ""}`}
      >
        {loading ? "—" : value}
      </p>
      {hint && (
        <p className="mt-3 text-[11px] tracking-wide text-bone/50">{hint}</p>
      )}
    </div>
  );
}
